<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        
        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo sub">
                    <router-link to="/alumnos/calificaciones">Alumnos</router-link>
                    <i class="fa fa-chevron-right"></i> Calificaciones
                  </span>
                </div>
                
              </div>

              <div class="contenido" v-if="this.data != null">
                <div>
                  <div class="row pt-3">
                    <div class="col-sm-6 text-center mb-3">
                      <div class="card">
                        <div class="col-12 datos text-left">
                          <p class="titulo">
                            <i class="fa fa-users"></i> Grupo
                          </p>
                          <div class="row py-3">
                            <div class="col-4 bold">Programa Académico:</div>
                            <div class="col-8">
                              {{this.data.programa}} - {{this.data.codigo}}
                              <br />
                              ({{this.data.tipo_ciclo_escolar}})
                            </div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">No. acuerdo:</div>
                            <div class="col-8">{{this.data.no_acuerdo}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Grupo:</div>
                            <div class="col-8">{{this.data.grupo}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Estado de titulacion:</div>
                            <div class="col-8">{{this.data.estado_de_titulacion}}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6 text-center mb-3">
                      <div class="card">
                        <div class="col-12 datos text-left">
                          <p class="titulo">
                            <i class="fa fa-user"></i> Alumno
                          </p>
                          <div class="row py-3">
                            <div class="col-4 bold">Matrícula:</div>
                            <div class="col-8">{{this.matricula}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Nombre:</div>
                            <div
                              class="col-8"
                            >{{this.data.nombre}} {{this.data.apellido_paterno}} {{this.data.apellido_materno}}</div>
                          </div>
                          <div class="row py-3">
                            <div class="col-4 bold">Email:</div>
                            <div class="col-8">
                              <a :href="'mailto:'+this.data.user_email">{{this.data.user_email}}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pb-2 pt-2">
                  <div class="col-6 col-md-6">
                    <span class="titulo sub">Asignaturas</span>
                  </div>
                  <!-- <div class="col-6 col-md-6">
                    <button class="btnblanco float-right">
                      Guardar ajustes
                      <i class="fa fa-save"></i>
                    </button>
                  </div>-->
                </div>

                <div class="pb-5">
                  <table
                    class="VueTables__table table table-striped table-bordered table-hover edicioncalificaciones"
                    style="overflow: hidden;"
                  >
                    <thead>
                      <tr>
                        <th>
                          <span class="VueTables__heading">Clave</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Asignatura</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Créditos</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Seriación</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Año</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Ciclo Escolar</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Docente</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Horarios</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Calificación</span>
                        </th>
                        <th>
                          <span class="VueTables__heading">Status</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in asignaturas" v-bind:key="item.clave">
                        <td>{{item.clave}}</td>
                        <td>{{item.asignatura}}</td>
                        <td>{{item.creditos}}</td>
                        <td>{{item.seriacion}}</td>
                        <td>{{item.ciclo_escolar_ano}}</td>
                        <td>{{item.ciclo_escolar}}</td>
                        <td>{{item.nombre_docente}}</td>
                        <td>{{item.horario}}</td>
                        <td class="calificacion">
                          <div
                            class="row no-gutters botonera"
                            v-bind:class="{editando: item.edicion}"
                          >
                            <div class="col-12">
                              <span class="non">{{item.calificacion}}</span>
                            </div>
                          </div>
                        </td>
                        <td>{{item.status}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Menu from "../../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      matricula: "",
      id_grupo: "",
      columns: ["matricula", "nombre", "user_email"],
      datos: null,
      data: null,
      asignaturas: null,

      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Clave",
          nombre: "Trimestre",
          user_email: "Calificación"
        },
        editableColumns: ["name"],
        sortable: ["nombre"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
    this.$store.state.user = JSON.parse(this.$cookie.get("useriee"));
    AOS.init();

    this.matricula = this.$route.params.matricula;
    this.id_grupo = this.$route.params.id_grupo;

    this.$store.state.loading = false;

    this.consulta();
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel,
        matricula: this.matricula,
        id_grupo: this.id_grupo
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      //console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "alumnos/cuenta/consulta-grupo-alumno.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            //console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];
              this.asignaturas = res.asignaturas;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    }
  }
};
</script>

